/* Native campaign popup. No app requests, tracking, or checkout modifications. */
(function () {
  'use strict';
  if (window.issenkaPopupInitialized) return;
  window.issenkaPopupInitialized = true;
  var instances = new Map();
  var editorSelected = false;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var memory = Object.create(null);

  function hash(text) {
    var value = 2166136261;
    for (var i = 0; i < text.length; i++) value = Math.imul(value ^ text.charCodeAt(i), 16777619);
    return (value >>> 0).toString(36);
  }
  function init(root) {
    root.querySelectorAll('[data-issenka-popup]').forEach(function (element) {
      if (instances.has(element)) return;
      var dialog = element.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var timer;
      var shown = false;
      var previousFocus;
      var media = window.matchMedia('(max-width: 749px)');
      var frequency = element.dataset.frequency;
      var key = 'issenka-popup:' + element.dataset.themeId + ':' + element.dataset.sectionId;
      var fingerprint = hash(dialog.innerHTML.replace(/\s+/g, ' '));
      var storage;
      try { storage = frequency === 'session' ? window.sessionStorage : window.localStorage; } catch (error) { /* Storage may be blocked. */ }
      function read() {
        try { return JSON.parse(storage ? storage.getItem(key) : memory[key]); } catch (error) { return null; }
      }
      function remember() {
        if (designMode || frequency === 'always') return;
        var value = JSON.stringify({content: fingerprint, time: Date.now()});
        memory[key] = value;
        try { if (storage) storage.setItem(key, value); } catch (error) { storage = null; }
      }
      function eligible() {
        if (shown) return false;
        if (element.dataset.enabled !== 'true' || element.dataset.eligible !== 'true') return false;
        if (element.dataset.mobile !== 'true' && media.matches) return false;
        if (frequency === 'always') return true;
        var last = read();
        if (!last || last.content !== fingerprint || !Number.isFinite(last.time)) return true;
        if (frequency === 'session') return false;
        return Date.now() - last.time >= Number(frequency) * 86400000;
      }
      function open(preview) {
        if (!element.isConnected || dialog.open || (!preview && !eligible())) return;
        // Avoid opening over another native dialog or while the tab is hidden.
        if (!preview && (document.hidden || document.querySelector('dialog[open]'))) return;
        previousFocus = document.activeElement;
        dialog.showModal();
        shown = true;
        document.documentElement.classList.add('issenka-popup-open');
        remember();
      }
      function restore() {
        document.documentElement.classList.remove('issenka-popup-open');
        if (previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus({preventScroll: true});
        previousFocus = null;
      }
      function close() { if (dialog.open) dialog.close(); restore(); }
      function cancel(event) { event.preventDefault(); close(); }
      function click(event) {
        if (event.target.closest('[data-popup-close]')) close();
        if (event.target === dialog) {
          var bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
        }
        if (event.target.closest('a[href]')) close();
      }
      function preview() { open(true); }
      function visibility() { if (!document.hidden) schedule(); }
      function schedule() {
        clearTimeout(timer);
        if (!designMode && eligible()) timer = setTimeout(function () { open(false); }, Math.max(0, Number(element.dataset.delay) || 0) * 1000);
      }
      var previewButton = element.querySelector('[data-popup-preview]');
      if (previewButton) previewButton.addEventListener('click', preview);
      dialog.addEventListener('click', click);
      dialog.addEventListener('cancel', cancel);
      dialog.addEventListener('close', restore);
      document.addEventListener('visibilitychange', visibility);
      var instance = {open: preview, close: close, destroy: function () {
        clearTimeout(timer); close();
        dialog.removeEventListener('click', click);
        dialog.removeEventListener('cancel', cancel);
        dialog.removeEventListener('close', restore);
        document.removeEventListener('visibilitychange', visibility);
        if (previewButton) previewButton.removeEventListener('click', preview);
        instances.delete(element);
      }};
      instances.set(element, instance);
      if (designMode && editorSelected) preview();
      else schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (instance, element) { if (event.target.contains(element)) instance.destroy(); });
  });
  document.addEventListener('shopify:section:select', function (event) {
    if (!designMode) return;
    editorSelected = !!event.target.querySelector('[data-issenka-popup]');
    instances.forEach(function (instance, element) { if (event.target.contains(element)) instance.open(); else instance.close(); });
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    if (!designMode || !event.target.querySelector('[data-issenka-popup]')) return;
    editorSelected = false;
    instances.forEach(function (instance, element) { if (event.target.contains(element)) instance.close(); });
  });
})();
